module.exports = "https://www.niulinkcloud.cn/_next/static/media/pcBanner0.bc1fede1fa5acddbe1fa3bc2b7e0303e.png";